import { gql } from '@apollo/client';

export const GET_LATEST_INSTITUTION_REGISTRATION = gql`
  query GetLatestInstitutionRegistration($institutionId: ID!) {
    registration: getLatestInstitutionRegistration(institutionId: $institutionId)
  }
`;
